import { useMemo } from 'react';

import qs from 'qs';
import { useLocation } from 'react-router-dom';

const useQueryParams = <T extends object>(): T => {
  const location = useLocation();

  return useMemo(
    () =>
      qs.parse(location.search, {
        ignoreQueryPrefix: true,
      }),
    [location.search],
  ) as T;
};

export default useQueryParams;
